import React, { useCallback, useMemo, useState } from 'react';
import { ComponentWrapper } from '../../helperComponents/componentWrapper/ComponentWrapper';
import sharedStyles from './Shared/styles';
import { StyleSheet, Text, View, ViewStyle } from 'react-native';
import { Header } from './Shared/Header';
import { mbTextStyles } from '@mightybyte/rnw.utils.style-utils';
import { textStyles } from '../../../constants/textStyles';
import { MB_Table, MB_TableProps } from '@mightybyte/rnw.components.table';
import { trpc } from '../../../apiCalls/trpcClient';
import { Indicators } from './Shared/Indicators';
import IncognitoIcon from '../../../resources/svgComponents/IncognitoIcon';
import {Spacer} from '../../helperComponents/Spacer';

const headerTextStyle = mbTextStyles([textStyles.normalText, { color: '#000000', textAlign: 'left' }]);
const headerConatinerStyle: ViewStyle = {
    justifyContent: 'center',
    paddingRight: 0,
};

const header: MB_TableProps['header'] = [
    { content: 'DeviceId', conatinerStyle: { ...headerConatinerStyle, justifyContent: undefined, minWidth: 200, maxWidth: 200, flex: 1 }, textStyle: headerTextStyle },
    { content: 'Registered users details', conatinerStyle: { ...headerConatinerStyle, justifyContent: 'flex-start',flex: 1 }, textStyle: headerTextStyle },
];

const SuspiciousAccounts = () => {

    const [page, setPage] = useState(1);
    const { data: { items, totalItems } = {}, isLoading } = trpc.admin.utils.getSuspiciousAccounts.useQuery({ page, pageSize: 10 });

    const data = useMemo(() => {
        return items?.map((item) => {
            const usersData = item.users.map((user) => {
                const date = user.createdAt.date
                return (
                    <View key={user.userId} style={styles.userDetails}>
                        <View style={{width: 200}}>
                            <Text style={[styles.cellText, styles.cellLeftText]} selectable numberOfLines={1}>{user.phoneNumber}</Text>
                        </View>

                        <Spacer width={10} />
                        <View style={{width: 160}}>
                            <Text style={[styles.cellText, styles.cellLeftText]} selectable numberOfLines={1}>{user.userName}</Text>
                        </View>
                        <Spacer width={10}/>
                        <View style={{width: 160}}>
                            <Text style={[styles.cellText, styles.cellLeftText, {textTransform: 'capitalize'}]} selectable numberOfLines={1}>{user.accountStatus}</Text>
                        </View>

                        <View style={{flex: 1}}>
                            <Text style={[styles.cellText, styles.cellLeftText, {color: '#0000008c'}]}>{`Created at: ${date.month}/${date.day}/${date.year}`}</Text>
                        </View>

                    </View>
                );
            })
            return [
                <View style={{width: 200, paddingTop: 16}}>
                    <Text style={[styles.cellText, styles.cellLeftText]} selectable numberOfLines={1}>{item.deviceId ?? 'N/A'}</Text>
                </View>,

                <View style={{paddingTop:16, width: '100%'}}>
                    {usersData}
                </View>
        ]});
    }, [items]);

    const keyExtractor = useCallback((index) => items?.[index].deviceId ?? index.toString(), [items]);
    const totalPages = useMemo(() => Math.ceil((totalItems || 0) / 10), [totalItems]);

    return (
        <ComponentWrapper
            innerContainerStyle={sharedStyles.innerContainer}
            containerStyle={sharedStyles.container}
            scrollViewStyle={sharedStyles.scrollView}
            wrapInScrollView
        >
            <Header />
            <View style={sharedStyles.body}>
                <View style={styles.content}>
                    <View style={styles.row}>
                        <View style={styles.row}>
                            <IncognitoIcon color="#F35E2E" size={30} />
                            <Text style={styles.titleText}>Suspicious Accounts</Text>
                        </View>
                    </View>
                    <MB_Table
                        header={header}
                        data={data}
                        headerStyle={styles.tableHeader}
                        rowStyle={styles.rowStyle}
                        style={styles.table}
                        keyExtractor={keyExtractor}
                        loading={isLoading}
                        loadingScreenProps={{ textColor: '#F35E2E' }}
                    />
                </View>
                <Indicators
                    page={page}
                    totalPages={totalPages}
                    onPageChange={setPage}
                />
            </View>
        </ComponentWrapper>
    );

};

export { SuspiciousAccounts };

const styles = StyleSheet.create({
    content: {
        backgroundColor: '#FFFFFF',
        borderRadius: 12,
        padding: 20,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    titleText: mbTextStyles([textStyles.largeText, {
        fontSize: 22,
        color: '#F35E2E',
        textAlign: 'left',
        marginLeft: 10,
    }]),
    input: {
        backgroundColor: '#FAFAFA',
        borderRadius: 22,
        borderWidth: 0,
        width: 304,
    },
    textInput: mbTextStyles([textStyles.normalText, {
        textAlign: 'left',
        color: '#000000',
        fontWeight: '400',
        marginLeft: 10,
    }]),
    table: {
        marginTop: 20,
        borderWidth: 0,
    },
    cellText: mbTextStyles([textStyles.smallText, {
        color: '#1E1E1E',
        fontWeight: '400',
        textAlign: 'center',
    }]),
    cellLeftText: {
        textAlign: 'left',
    },
    userDetails: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100%',
        marginBottom: 8,
        paddingBottom: 8,
        borderBottomWidth: 1,
        borderBottomColor: '#f2f2f2'
    },
    tableHeader: {
        height: 50,
        backgroundColor: '#FFF4F0',
        borderBottomWidth: 0,
        borderBottomRightRadius: 10,
        borderBottomLeftRadius: 10,
        marginBottom: -4,
        zIndex: 2,
    },
    rowStyle: {
        backgroundColor: '#FFFFFF',
        justifyContent: 'flex-start'
    },
});
